export default __webpack_public_path__ + "static/media/purple-color-signal.43928d0f.svg";